export class PipeModel {
    public plannerName: string;
    public productId: number;
    public pipeLength: number;
    public unit: string;
    public diameter: number;
    public altitude: number;
    public isUnderground: boolean;
}